import { Container } from '@dma/ui';
import type { AboutContentDto } from '../application/dto/AboutContentDto';
import './WhyChooseUs.css';

export interface WhyChooseUsProps {
  reasons: AboutContentDto['whyChooseUs'];
}

export function WhyChooseUs({ reasons }: WhyChooseUsProps) {
  if (reasons.length === 0) {
    return null;
  }
  return (
    <section className="dma-why-choose-us" aria-labelledby="dma-why-choose-us-heading">
      <Container>
        <h2 id="dma-why-choose-us-heading">چرا داریوش معدن آذر؟</h2>
        <ul className="dma-why-choose-us__list">
          {reasons.map((reason) => (
            <li key={reason}>{reason}</li>
          ))}
        </ul>
      </Container>
    </section>
  );
}
